import { ChangeEvent, FC, useState } from 'react';
import { TCheckedItem } from '../types';
import styles from './styles.module.scss';

interface CheckedItemProps {
	item: TCheckedItem;
	checkedItemsIds: number[];
	onSelect: (item: TCheckedItem, checked: boolean) => void;
}

export const CheckedItem: FC<CheckedItemProps> = ({
	item,
	checkedItemsIds,
	onSelect,
}) => {
	const [isChecked, setChecked] = useState(checkedItemsIds.includes(item.id));

	const checkedChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
		const checked = event.target.checked;
		onSelect(item, checked);
		setChecked(checked);
	};

	const handleContainerClick = (event: React.MouseEvent<HTMLDivElement>) => {
		if ((event.target as HTMLElement).tagName === 'INPUT') return;

		const newCheckedState = !isChecked;
		onSelect(item, newCheckedState);
		setChecked(newCheckedState);
	};

	return (
		<div
			className={styles['checked-items-list__item']}
			onClick={handleContainerClick}
		>
			<div className={styles['checked-items-list__item-wrapper']}>
				<div className={styles['checked-items-list__checkbox']}>
					<input
						type="checkbox"
						onChange={checkedChangeHandler}
						id={`checkbox-${item.name}`}
						checked={isChecked}
					/>
				</div>
				<div className={styles['checked-items-list__label']}>
					{item.name}
				</div>
			</div>
			{item.info.map((infoItem, index) => (
				<div
					key={index}
					className={styles['checked-items-list__description']}
				>
					{infoItem}
				</div>
			))}
		</div>
	);
};
